/**
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import type { MutationsObject } from '@kp/js-model';
import { LookupCollection } from './BaseCollection';

export class OrtGemeinde extends BaseModel {
    id: number | null = null
    ort_id: number | null = null
    gemeinde_id: number | null = null

    //view fields
    gemeinde: string | null = null
    gemeinde_bfsnr: number | null = null
    ort: string | null = null
    ort_kurz: string | null = null
    ort_plz: string | null = null
    ort_onrp: string | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'ortGemeinde';
    }

}

export class OrtGemeindeCollection extends LookupCollection<OrtGemeinde> {
    protected modelCls = OrtGemeinde;
    getModelClassName(): string {
        return 'ortGemeinde'
    }
}

